module.exports = __webpack_public_path__ + "static/media/success_icon.df96e958.svg";